/* eslint-disable no-prototype-builtins */

import axios from 'axios';
import store from '@/store'
import router from "@/router";

let $http = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}`,
    headers: {
        'X-Requested-With' : 'XMLHttpRequest',
        'Content-Type': 'application/json; charset="utf-8"'
    },
    withCredentials: false,
    crossDomain: true,
    params: {}
});

$http.interceptors.request.use(request => {
    request.headers['Accept-Language'] = document.documentElement.lang
    if (request.url.includes('auth')) {
        request.headers.Authorization = store.getters.GET_AUTHORIZATION._token
        request.headers.Accept = 'application/json'
    }
    return request
})

$http.interceptors.response.use(response => {
    if (response.data.hasOwnProperty('_token')) {
        store.dispatch('setUser', response.data.user).catch()
        store.dispatch('setAuthorization', {
            _token: response.data._token,
            _expires_at: response.data._expires_at
        }).catch()
    }
    if (response.data.hasOwnProperty('message')) {
        store.dispatch('setAlert', { show: true, type: 'success', message: response.data.message }).then()
    }
    return response
}, error => {
    try {
        switch (error.response.status) {
            case 401:
                store.dispatch('setAlert', { show: true, type: 'error', message: error.response.data.error })
                    .then(() => {
                        store.dispatch('setAuthorization', null)
                        store.dispatch('setUser', null)
                        router.push({ name: 'main' }).catch()
                    })
                break
            case 500:
                store.dispatch('setAlert', { show: true, type: 'error', message: error.response.data.error }).then()
                break
            default:
                break
        }
    } catch (e) {
        console.log(e)
    }

})

const HttpService = {
    install(Vue) {
        Vue.prototype.$http = $http;
    }
};

export default (HttpService);
